if (!customElements.get('content-accordion')) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.activeContentId = null;
    }
    
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-accordion-toggle]') || e.target.closest('[data-accordion-submenu-toggle]');
        if(!clickedElement) return;
        if (clickedElement.dataset.accordionToggle) {
          const id = clickedElement.dataset.accordionToggle;
          const content = this.querySelector(`[data-accordion-content="${id}"]`);
          const rotatedEl = clickedElement.querySelector('[data-rotate-active]');
          const rotation = rotatedEl?.dataset.rotateActive || 0;
          
          if (id === this.activeContentId || content.clientHeight > 0) {
            content.style.height = 0;
            this.activeContentId = null;
            
            if(!rotatedEl) return;
            rotatedEl.style.transform = null;
            
            return;
          }
          
          [...this.querySelectorAll('[data-accordion-content]')]
            .filter((x) => !x.isSameNode(content))
            .forEach((x) => x.style.height = 0);
          [...this.querySelectorAll('[data-accordion-toggle]')]
            .filter((x) => !x.isSameNode(clickedElement))
            .forEach((x) => {
              if (!x.querySelector('[data-rotate-active]')) return;
              x.querySelector('[data-rotate-active]').style.transform = null;
            })
          
          content.style.height = `${content.scrollHeight || 0}px`;        
          this.activeContentId = id;
          
          if (!rotatedEl) return;
          rotatedEl.style.transform = `rotate(${rotation}deg)`;
        } else if (clickedElement.dataset.accordionSubmenuToggle) {
          const id = clickedElement.dataset.accordionSubmenuToggle;
          const content = this.querySelector(`[data-accordion-submenu-content="${id}"]`);
          const parentContent = clickedElement.closest('[data-accordion-content]');
          
          if (content.style.height === '0px') {
            clickedElement.innerText = clickedElement.innerText.replace('+ MORE', '- LESS');
            content.style.height = `${content.scrollHeight || 0}px`;   
            parentContent.style.height = `${parseInt(parentContent.style.height) + content.scrollHeight || 0}px`;
          } else {
            clickedElement.innerText = clickedElement.innerText.replace('- LESS', '+ MORE');
            content.style.height = '0px';   
            parentContent.style.height = `${parseInt(parentContent.style.height) - content.scrollHeight || 0}px`;
          }
        }
      });
      const accordionButtons = this.querySelectorAll('button');
      accordionButtons.forEach(button => {
        button.classList.contains('open') ? button.click() : null
      })
    }
  }
  
  customElements.define('content-accordion', Accordion);
}

/*
EXAMPLE USAGE
*
*
* 
* 
* 
<content-accordion class="px-10"> {% for link in menu.links %} 
  <button data-accordion-toggle="{{ link.handle }}-{{ forloop.index }}" class="flex items-center justify-between text-xl pt-7 w-full">
    {{ link.title }}
    <div aria-hidden="true" class="w-3.5 h-3.5 relative">
      <span class="absolute top-1/2 transform translate-y-1/2 left-0 w-full block border border-current"></span>
      <span class="absolute block w-full h-0.5 top-1/2 transform translate-y-1/2">
        <span data-rotate-active class="transform rotate-90 transition duration-200 left-0 w-full block border border-current"></span>
      </span>
    </div>
  </button>
  <div class="overflow-hidden transition-all duration-500" style="height: 0;" data-accordion-content="{{ link.handle }}-{{ forloop.index }}">
    <ul class="pt-7 flex flex-col gap-2 text-secondaryDark"> {% for child_link in link.links %} <li>
        <a href="{{ child_link.url }}">{{ child_link.title }}</a>
      <li> {% endfor %}
    </ul>
    <!-- optional submenu (example usage on collection filter drawer) -->
    <div class="overflow-hidden transition-all duration-500" style="height: 0;" data-accordion-submenu-content="submenu-{{ filter.label }}">
      <ul class="flex flex-col gap-2 text-small">
        <li class="relative flex items-center pb-3 pt-3 {% unless forloop.last %} border-b {% endunless %}"> Some additional content in a sub-accordion
        <li>
      </ul>
    </div>
    <button class="py-5 text-secondaryDark" data-accordion-submenu-toggle="submenu-{{ filter.label }}"> + MORE {{ filter.label | upcase }}S </button>
    <!-- end optional submenu (example usage on collection filter drawer) -->
  </div> {% endfor %}
</content-accordion>
*/